import {
  BooleanInput,
  DateInput,
  SimpleForm,
  SimpleFormProps,
  TextInput,
  required
} from 'react-admin';
import { CustomEditor, UploadImageInput } from '../../components';
import { dateFormatter } from '../../utils'
const now = Date.now();



export default function PostsForm(props: Partial<SimpleFormProps>) {
  return (
    <SimpleForm {...props} redirect="list">
      <TextInput
        autoComplete="off"
        fullWidth
        label="Título"
        source="title"
        validate={[required()]}
      />

      <DateInput
        autoComplete="off"
        defaultValue={now}
        format={dateFormatter}
        label="Data"
        source="date"
        validate={[required()]}
      />

      <UploadImageInput
        fullWidth
        helperText="É possível enviar imagens no formato JPEG com dimensões recomendadas de 1250x624px."
        label="Imagem"
        upploadOptions={{
          maxSize: [612, 315]
        }}
        mimeTypes={['image/jpeg']}
        source="image"
        validate={[required()]}
        cropOptions={{
          aspectRatio: 396 / 203
        }}
      />

      <CustomEditor
        fullWidth
        label="Texto"
        source="text"
        validate={[required()]}
      />

      <BooleanInput label="Ativo" source="active" defaultValue />
    </SimpleForm>
  );
}
